import React, { useEffect, useCallback } from "react";
import mqtt_topics from "../../../mqtt/mqtt_topics";
import { useStateIfMounted } from "use-state-if-mounted";
import Forecast from "./forecast";

const api_key = "45442c85d6ae4aa69a4132253230903";

const WeatherWidget = () => {
  const [weatherData, setWeatherData] = useStateIfMounted(null);
  const [status, setStatus] = useStateIfMounted("loading"); // "loading" | "success" | "error"

  let location = "Lebanon";
  if (
    mqtt_topics.latitude != undefined &&
    mqtt_topics.latitude != "" &&
    mqtt_topics.longitude != undefined &&
    mqtt_topics.longitude != ""
  ) {
    location = mqtt_topics.latitude + "," + mqtt_topics.longitude;
  }

  const fetchData = useCallback(async () => {
    setStatus("loading");
    try {
      const response = await fetch(
        "https://api.weatherapi.com/v1/current.json?key=" +
          api_key +
          "&q=" +
          encodeURIComponent(location),
      );

      let data = null;
      try {
        data = await response.json();
      } catch (parseError) {
        data = null;
      }

      if (!response.ok || data == null || data.error != undefined) {
        setWeatherData(null);
        setStatus("error");
        return;
      }

      setWeatherData(data);
      setStatus("success");
    } catch (error) {
      console.error("Weather fetch failed:", error);
      setWeatherData(null);
      setStatus("error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (status === "loading") {
    return (
      <div className="loginrow text-light" title="Device geolocation weather">
        <div style={styles.loadingRow}>
          <span style={styles.spinner} />
          <span style={styles.muted}>Loading weather…</span>
        </div>
      </div>
    );
  }

  if (status === "error" || weatherData == null) {
    return (
      <div className="loginrow text-light">
        <strong>Edit device geolocation to view weather.</strong>
        <button style={styles.retryBtn} onClick={fetchData}>
          Retry
        </button>
      </div>
    );
  }

  const current = weatherData.current != undefined ? weatherData.current : null;
  const loc = weatherData.location != undefined ? weatherData.location : null;
  const condition =
    current != null && current.condition != undefined
      ? current.condition
      : null;

  return (
    <div className="loginrow text-light" title="Device geolocation weather">
      <div style={styles.mainRow}>
        {condition != null && condition.icon != undefined && (
          <img
            src={condition.icon}
            alt={condition.text != undefined ? condition.text : "Weather icon"}
            style={styles.icon}
          />
        )}

        <div style={styles.info}>
          <div style={styles.topLine}>
            {loc != null && loc.name != undefined && (
              <span style={styles.location}>{loc.name}</span>
            )}
            {condition != null && condition.text != undefined && (
              <span style={styles.condition}>{condition.text}</span>
            )}
          </div>

          <div style={styles.tempLine}>
            {current != null && current.temp_c !== undefined && (
              <span style={styles.temp}>{Math.round(current.temp_c)}°C</span>
            )}
            {current != null && current.feelslike_c !== undefined && (
              <span style={styles.feelsLike}>
                Feels like {Math.round(current.feelslike_c)}°C
              </span>
            )}
          </div>
        </div>
      </div>

      <Forecast />
    </div>
  );
};

const styles = {
  loadingRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
  },
  spinner: {
    width: "1rem",
    height: "1rem",
    borderRadius: "50%",
    border: "2px solid rgba(255,255,255,0.3)",
    borderTopColor: "currentColor",
    animation: "weather-spin 0.8s linear infinite",
  },
  muted: {
    opacity: 0.75,
  },
  retryBtn: {
    marginLeft: "0.75rem",
    padding: "0.15rem 0.6rem",
    borderRadius: "8px",
    border: "1px solid currentColor",
    background: "transparent",
    color: "inherit",
    cursor: "pointer",
    fontSize: "0.85rem",
  },
  mainRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.75rem",
  },
  icon: {
    width: "3rem",
    height: "3rem",
    flexShrink: 0,
  },
  info: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "0.15rem",
  },
  topLine: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "center",
    gap: "0.5rem",
    flexWrap: "wrap",
  },
  location: {
    fontWeight: 600,
    fontSize: "0.95rem",
  },
  condition: {
    fontSize: "0.85rem",
    opacity: 0.85,
  },
  tempLine: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "center",
    gap: "0.6rem",
  },
  temp: {
    fontSize: "1.4rem",
    fontWeight: 700,
  },
  feelsLike: {
    fontSize: "0.8rem",
    opacity: 0.7,
  },
};

export default WeatherWidget;
